"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var request_sender_1 = require("@bigcommerce/request-sender");
var browser_support_1 = require("./browser-support");
var script_loader_1 = require("./script-loader");
function createScriptLoader() {
    return new script_loader_1.default(new browser_support_1.default(), request_sender_1.createRequestSender());
}
exports.default = createScriptLoader;
//# sourceMappingURL=create-script-loader.js.map